import { render } from "./AppInlineMenu.vue?vue&type=template&id=58c5a25e&scoped=true"
import script from "./AppInlineMenu.vue?vue&type=script&lang=js"
export * from "./AppInlineMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c5a25e"]])

export default __exports__